// Component/Workshop/Notifications/CaseNotificationDropdown.jsx
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function CaseNotificationDropDown({ notifications, onDismiss, onClose }) {
  const navigate = useNavigate();
  const wrapperRef = useRef(null);

  // ── Close on outside click ──────────────────────────────────────────────
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        onClose();
      }
    };
    // capture phase so it fires before the bell button's own onClick toggles state again
    document.addEventListener("mousedown", handleClickOutside, true);
    return () => document.removeEventListener("mousedown", handleClickOutside, true);
  }, [onClose]);

  const handleClick = (n) => {
    onDismiss(n.id);
    onClose();
    if (n.caseId) navigate(`/admin/cases/${n.caseId}`);
  };

  return (
    <div
      ref={wrapperRef}
      style={{
        position: "absolute",
        top: 44,
        right: 0,
        width: 320,
        background: "var(--wd-card)",
        border: "1px solid var(--wd-border-md)",
        borderRadius: 10,
        boxShadow: "0 16px 40px rgba(0,0,0,.5)",
        zIndex: 50,
        maxHeight: 360,
        overflowY: "auto",
      }}
    >
      <div
        style={{
          padding: "10px 14px",
          fontSize: 12,
          fontWeight: 700,
          color: "var(--wd-t2)",
          borderBottom: "1px solid var(--wd-border)",
        }}
      >
        Notifications
      </div>

      {notifications.length === 0 ? (
        <div style={{ padding: "20px 14px", fontSize: 12, color: "var(--wd-t3)", textAlign: "center" }}>
          No new notifications
        </div>
      ) : (
        notifications.map((n) => (
          <div
            key={n.id}
            onClick={() => handleClick(n)}
            style={{
              padding: "10px 14px",
              fontSize: 12,
              color: "var(--wd-t1)",
              cursor: "pointer",
              borderBottom: "1px solid var(--wd-border)",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "var(--wd-hover)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
          >
            <span>{n.subject}</span>
            {n.createdAt && (
              <span style={{ fontSize: 10, color: "var(--wd-t3)" }}>
                {new Date(n.createdAt).toLocaleString()}
              </span>
            )}
          </div>
        ))
      )}
    </div>
  );
}